import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { ellipsisMultiline } from '@/styles/helpers';

export const Box = styled.div`
  background-color: ${({ theme }) => theme.palette.primary.background};
  padding: 25px 15px;
`;

export const Ad = styled.div`
  background-color: ${({ theme }) => theme.palette.primary.background};
  display: grid;
  grid-template-columns: 70px 1fr 10px;
  gap: 10px;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary.border};
`;

export const AdImage = styled.img`
  height: 70px;
  width: 70px;
  border-radius: 7px;
  object-fit: cover;
`;

export const Price = styled(Typography.Numbers)`
  margin-bottom: 2px;
`;

export const Logo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 15px;
`;

export const Name = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const Value = styled(Typography.Body)<{ isAlignLeft?: boolean }>`
  ${ellipsisMultiline(1)}
  text-align: ${({ isAlignLeft }) => (isAlignLeft ? 'left' : 'right')};
`;

export const Total = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-top: 1px solid ${({ theme }) => theme.palette.primary.border};
  padding-top: 20px;
`;

export const TotalValue = styled(Typography.Title)`
  text-align: right;
`;
